import React from "react";

/**
 * LoadMoreButton component
 * Renders a button to load more products when clicked
 */
const LoadMoreButton = ({ onClick, isVisible }) => {
  if (!isVisible) {
    return (<div>&nbsp;</div>);
  }

  return (
    <div className="flex justify-center mt-6">
      <button
        onClick={onClick}
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
      >
        Load More
      </button>
    </div>
  );
};

export default LoadMoreButton;